import React, { forwardRef } from "react";
import { ButtonProps } from "rsuite";

import "./index.scss";

// `form` links a submit button that sits outside its <form> (rsuite's ButtonProps omits it).
interface AppButtonProps extends ButtonProps {
  form?: string;
}

// forwardRef so rsuite's `Whisper` can attach its hover/focus ref to
// the real <button> -- Whisper clones its single child and sets a ref on it; a plain function
// component here would make that ref land on nothing (React warns and drops it) instead of the
// button. The wrapper div is presentational only and was never a valid ref target for that purpose.
const Button = forwardRef<HTMLButtonElement, AppButtonProps>((props, ref) => {
  return (
    <div className="button-wrapper">
      <button ref={ref} {...props} />
    </div>
  );
});

Button.displayName = "Button";

export default Button;
